import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { Calendar } from "lucide-react";
import { Logo } from "@/components/Logo";

export const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const goBook = () => navigate("/bookings");

  const linkClass = ({ isActive }) =>
    `relative text-sm font-semibold tracking-wide uppercase transition-colors duration-200 py-1 ${
      isActive ? "text-[#f4d160]" : "text-white/80 hover:text-white"
    } after:content-[''] after:absolute after:left-0 after:-bottom-0.5 after:h-[2px] after:bg-[#d4af37] after:transition-all after:duration-300 ${
      isActive ? "after:w-full" : "after:w-0 hover:after:w-full"
    }`;

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-[#09090b]/85 backdrop-blur-xl border-b border-[#d4af37]/15">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 h-[68px] sm:h-[76px] flex items-center justify-between gap-3">
        <NavLink to="/" data-testid="header-logo-link" aria-label="MENZY home">
          <Logo size="sm" className="sm:hidden" />
          <Logo size="md" className="hidden sm:flex" />
        </NavLink>

        <nav className="flex items-center gap-5 sm:gap-9">
          <NavLink to="/" end className={linkClass} data-testid="nav-home-link">
            Home
          </NavLink>
          <NavLink to="/bookings" className={linkClass} data-testid="nav-bookings-link">
            Bookings
          </NavLink>
          <button
            onClick={goBook}
            data-testid="nav-book-now-button"
            className="gold-surface text-[#0b0b0c] font-extrabold text-xs sm:text-sm uppercase tracking-wide px-4 sm:px-6 py-2.5 rounded-full flex items-center gap-2 shadow-[0_0_22px_rgba(212,175,55,0.4)] transition-transform duration-300 hover:scale-[1.04]"
          >
            <Calendar className="h-4 w-4" strokeWidth={2.5} />
            <span className="hidden xs:inline sm:inline">Book Now</span>
            <span className="xs:hidden sm:hidden">Book</span>
          </button>
        </nav>
      </div>
      {location.pathname === "/bookings" && <div className="gold-divider" />}
    </header>
  );
};
